import { render } from "./VirtualMachineCpuMemory.vue?vue&type=template&id=8ef1a11a"
import script from "./VirtualMachineCpuMemory.vue?vue&type=script&lang=js"
export * from "./VirtualMachineCpuMemory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__